import { memo, useEffect, useState } from 'react';
import { SelectPicker } from 'rsuite';
import styles from './OfferGroupCell.module.scss';
import { IRowData } from './OfferTable';

interface OfferGroupCellProps {
  rowData: IRowData;
  blockOptions: { label: string; value: string }[];
  onChange?: (value: string, rowData: IRowData) => void;
  disabled?: boolean;
}

const OfferGroupCell = ({ rowData, blockOptions, onChange, disabled = false }: OfferGroupCellProps) => {
  const [value, setValue] = useState(rowData.offer_group_id);

  useEffect(() => {
    setValue(rowData.offer_group_id);
  }, [rowData.offer_group_id]);

  const handleChange = (val: string) => {
    if (disabled) return;

    setValue(val);
    if (onChange) {
      onChange(val, rowData);
    }
  };

  return (
    <div onClick={e => e.stopPropagation()}>
      <SelectPicker
        className={styles['offer-group-select']}
        appearance="default"
        data={blockOptions}
        labelKey="label"
        valueKey="value"
        value={value}
        cleanable={false}
        searchable={false}
        disabled={disabled}
        onChange={handleChange}
        style={{ width: '100%' }}
        container={document.body}
      />
    </div>
  );
};

export default memo(OfferGroupCell);
